import ContentAssetExpanded from "@components/BasicComponents/ContentAsset/Expanded/ContentAssetExpanded"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAsset, {
	ContentAssetNewProps,
} from "@components/WebsiteRevamp/ContentAsset/ContentAsset"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {
	data?: AdvancedSideAssetModuleType
	withAutoSizing?: boolean
	contentAssetProps?: ContentAssetNewProps
	shortDesc?: number
	separatorSize?: 8 | 16 | 32 | 64 | 128 | 256
}

const ContentAssetSwitcher = (props: Props) => {
	if (typeof props.data === "undefined") {
		return <></>
	}

	const mainContent = props.data.mainContent

	if (props.data.expanded) {
		return (
			<ContentAssetExpanded
				mainData={props.data}
				{...props.contentAssetProps}
			/>
		)
	}

	return (
		<>
			{mainContent?.map(
				(element: AdvancedSideAssetMainContent, index: number) => {
					return (
						<React.Fragment key={index}>
							<ContentAsset
								{...props.contentAssetProps}
								data={element}
								shortDesc={props.shortDesc}
							/>
							{mainContent?.length > index + 1 && (
								<Separator
									size={
										props.separatorSize
											? props.separatorSize
											: 64
									}
								/>
							)}
						</React.Fragment>
					)
				},
			)}
		</>
	)
}

export default ContentAssetSwitcher
